export const state = () => ({
    key   : '',
});

export const mutations = {
    setKey (state, key) {
        state.key = key;
    }
};
